exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".error{margin-top:10px;opacity:.5}.theme-clean-dark .error{color:#fff}.theme-clean-light .error{color:#333}.theme-vantage-dark .error{color:#fff}.theme-vantage-light .error{color:#333}.theme-slanted-dark .error{color:#fff}.theme-slanted-light .error{color:#333}", ""]);

// exports
